enum profileStatusName {
  active = "Active",
  stopped = "Stopped",
  waiting = "Waiting",
}

export default profileStatusName;
